import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from "reactstrap";
import { Button } from "reactstrap";
import axios from "axios";
import validation from '../Validations/Buyer-All.js';

const FeatureOne = () => {

  const [clients, setClients] = useState([]);
  const [message, setMessage] = useState("");
  const [messageerror, setMessageerror] = useState("");
  const [values, setValues] = useState({
    name: '',
    panno: '',
    contact: '',
    email: '',
    image1: null, // Added state for image 1
    image2: null, // Added state for image 2
    image3: null, // Added state for image 3
    image4: null, // Added state for image 4
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    // Fetch data from the API endpoint
    axios.get('https://bidtowin-b0bdf12bc1cf.herokuapp.com/getBuyersData')
      .then(response => {
        // Store the fetched data in the state
        setClients(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []); // Run this effect only once when the component mounts

  const handleInput = (event) => {
    setValues(prev => ({ ...prev, [event.target.name]: event.target.value }));
  }

  const handleFileChange = (event, imageNumber) => {
    const file = event.target.files[0];
    setValues(prev => ({ ...prev, [`image${imageNumber}`]: file }));
  }
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    setErrors(validation(values));

    if (errors.name === "" && errors.panno === "" && errors.contact === "" && errors.email === "") {
       // Disable the button immediately
      // For simplicity, I'm just checking if all four images are selected
      if (values.image1 && values.image2 && values.image3 && values.image4) {
        setIsSubmitting(true);
        // If all images are selected, proceed with the form submission
        const formData = new FormData();
        formData.append('name', values.name);
        formData.append('panno', values.panno);
        formData.append('contact', values.contact);
        formData.append('email', values.email);
        formData.append('image1', values.image1);
        formData.append('image2', values.image2);
        formData.append('image3', values.image3);
        formData.append('image4', values.image4);

        axios.post('https://bidtowin-b0bdf12bc1cf.herokuapp.com/buyers', formData)
          .then(res => {
            if (res.data === "Exists") {
              setMessageerror("Buyer Email Exists! Please Recheck & Try Again.");
              setMessage("");
              setIsSubmitting(false); 
            } else {
              

              // Fetch data from the API endpoint
              axios.get('https://bidtowin-b0bdf12bc1cf.herokuapp.com/getBuyersData')
                .then(response => {
                  // Store the fetched data in the state
                  setClients(response.data);
                })
                .catch(error => {
                  console.error('Error fetching data:', error);
                });

              setMessage("Operation Success! Record was created successfully!");
              setMessageerror("");
              event.target.reset();
              setIsSubmitting(false); 
            }
          })
          .catch(err => console.log(err));
      } else {
        // If any image is not selected, show error message
        setErrors(prev => ({
          ...prev,
          image1: !values.image1 ? "Please select Image 1" : "",
          image2: !values.image2 ? "Please select Image 2" : "",
          image3: !values.image3 ? "Please select Image 3" : "",
          image4: !values.image4 ? "Please select Image 4" : "",
        }));
      }
    }
  }

  var bgColors = { "light": "white",
  "greyish": "#2F2F2E"
};

const handleDelete = (clientId) => {
  // Make an API call to delete the client
  axios.delete(`https://bidtowin-b0bdf12bc1cf.herokuapp.com//buyers/${clientId}`)
    .then(response => {
      // If deletion is successful, update the clients array to remove the deleted client
      setClients(clients.filter(client => client.Id !== clientId));
    })
    .catch(error => {
      console.error('Error deleting client:', error);
      // Handle error, such as displaying an error message
    });
};

  return (
    <div style={{ paddingTop: 90 }}>
      <Container>
        <Row className='align-items-center'>
          <Col xl="12">
            <div>
              <div style={{ marginBottom: 10 }}>
              <h5 style={{fontWeight:"bold",color:"brown",marginBottom:5}}>Create New Buyer Profile</h5>
              <p style={{color:'GrayText'}}>The following control helps in registering new buyers to the network.<br/>Simply use the following form to create a new buyer record.</p>
                {message && <p style={{ padding: 5, backgroundColor: "green", color: "white", borderRadius: 2 }}>{message}</p>}
                {messageerror && <p style={{ padding: 5, backgroundColor: "red", color: "white", borderRadius: 2 }}>{messageerror}</p>}
              </div>
            </div>
          </Col>
        </Row>
        <form className="is-alter" action="" onSubmit={handleSubmit}>
        <Row>
          <Col md="6">
            <div>
              <div style={{ padding: 10, margin: "10px 2px", border: "solid #fafafa 2px", borderRadius: "5px", backgroundColor: bgColors.light }}>
               
               
              
                 
                  <div className="form-group">
                    <label className="form-label" htmlFor="name">
                      Full Name
                    </label>
                    <div className="form-control-wrap">
                      <input onChange={handleInput}
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter Buyer Name"
                        className="form-control-lg form-control"
                      />
                       {errors.name && <span className="text-danger" style={{ fontSize: "0.8rem", fontWeight: "bolder" }}>{errors.name}</span>}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="panno">
                      PAN No.
                    </label>
                    <div className="form-control-wrap">
                      <input onChange={handleInput}
                        type="text"
                        id="panno"
                        name="panno"
                        placeholder="Enter PAN No."
                        className="form-control-lg form-control"
                      />
                      {errors.panno && <span className="text-danger" style={{ fontSize: "0.8rem", fontWeight: "bolder" }}>{errors.panno}</span>}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="contact">
                      Contact No.
                    </label>
                    <div className="form-control-wrap">
                      <input onChange={handleInput}
                        type="text"
                        id="contact"
                        name="contact"
                        placeholder="Enter Contact No."
                        className="form-control-lg form-control"
                      />
                      {errors.contact && <span className="text-danger" style={{ fontSize: "0.8rem", fontWeight: "bolder" }}>{errors.contact}</span>}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="email">
                      Email Address
                    </label>
                    <div className="form-control-wrap">
                      <input onChange={handleInput}
                        type="text"
                        id="email"
                        name="email"
                        placeholder="Enter Email Address"
                        className="form-control-lg form-control"
                      />
                      {errors.email && <span className="text-danger" style={{ fontSize: "0.8rem", fontWeight: "bolder" }}>{errors.email}</span>}
                    </div>
                  </div>

                  

                 
                

              </div>

            </div>
          </Col>
          <Col  md="6">
                {/* Image uploader 1 */}
                <div className="form-group">
                    <label className="form-label" htmlFor="image1">
                      Upload PAN
                    </label>
                    <div className="form-control-wrap">
                      <input onChange={(e) => handleFileChange(e, 1)}
                        type="file"
                        id="image1"
                        name="image1"
                        accept="image/*" // Accept only image files
                        className="form-control-lg form-control"
                      />
                      {errors.image1 && <span className="text-danger" style={{ fontSize: "0.8rem", fontWeight: "bolder" }}>{errors.image1}</span>}
                    </div>
                  </div>

                  {/* Image uploader 2 */}
                  <div className="form-group">
                    <label className="form-label" htmlFor="image2">
                      Upload Aadhar
                    </label>
                    <div className="form-control-wrap">
                      <input onChange={(e) => handleFileChange(e, 2)}
                        type="file"
                        id="image2"
                        name="image2"
                        accept="image/*" // Accept only image files
                        className="form-control-lg form-control"
                      />
                      {errors.image2 && <span className="text-danger" style={{ fontSize: "0.8rem", fontWeight: "bolder" }}>{errors.image2}</span>}
                    </div>
                  </div>

                  {/* Image uploader 3 */}
                  <div className="form-group">
                    <label className="form-label" htmlFor="image3">
                      Upload Payment Receipt
                    </label>
                    <div className="form-control-wrap">
                      <input onChange={(e) => handleFileChange(e, 3)}
                        type="file"
                        id="image3"
                        name="image3"
                        accept="image/*" // Accept only image files
                        className="form-control-lg form-control"
                      />
                      {errors.image3 && <span className="text-danger" style={{ fontSize: "0.8rem", fontWeight: "bolder" }}>{errors.image3}</span>}
                    </div>
                  </div>

                  {/* Image uploader 4 */}
                  <div className="form-group">
                    <label className="form-label" htmlFor="image4">
                      Upload Cancelled Cheque
                    </label>
                    <div className="form-control-wrap">
                      <input onChange={(e) => handleFileChange(e, 4)}
                        type="file"
                        id="image4"
                        name="image4"
                        accept="image/*" // Accept only image files
                        className="form-control-lg form-control"
                      />
                      {errors.image4 && <span className="text-danger" style={{ fontSize: "0.8rem", fontWeight: "bolder" }}>{errors.image4}</span>}
                    </div>
                  </div>      
          </Col>
          <Col  md="12">
          <div className="form-group">
                    <Button type="submit" disabled={isSubmitting} color="primary" size="lg" className="btn-block">
                    {isSubmitting ? 'Please Wait...' : 'Create Record'}
                    </Button>
                  </div>      
          </Col>
        </Row>
        </form>
      </Container>
    </div>
  )
}

export { FeatureOne };
